import 'react-toggle/style.css';

import React from 'react';
import { validated } from 'react-custom-validation';
import moment from 'moment';
import classNames from 'classnames';
import Toggle from 'react-toggle';
import DatePicker from 'react-datepicker';

import ActionMenu from 'components/ActionMenu';
import ActionMenuButton from 'components/ActionMenuButton';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Icon from 'components/Icon';
import ModalButton from 'components/ModalButton';
import TextArea from 'components/TextArea';

import { RECURRING_FREQUENCY_OPTIONS, ASSIGNMENT_STATES } from '../constants';

class AssignmentEditAdvancedForm extends React.Component {
    static propTypes = {
        assignment: React.PropTypes.object.isRequired,
        cancelAdvancedChanges: React.PropTypes.func.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        handleDateChange: React.PropTypes.func.isRequired,
        handleRecurranceChange: React.PropTypes.func.isRequired,
        onValid: React.PropTypes.func.isRequired,
        onInvalid: React.PropTypes.func.isRequired,
        openModal: React.PropTypes.func.isRequired
    };

    _handleTriggerClick(event) {
        let target = event.target;

        while(target.getAttribute('class') == null || target.getAttribute('class') !== 'recurring__action-menu') {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
    }

    _handleChange(value, name) {
        this.props.handleRecurranceChange(value, name);
    }

    render() {
        let { assignment, cancelAdvancedChanges, handleChange, handleDateChange, handleRecurranceChange, isSaving, onValid, onInvalid, $field, $validation } = this.props;


        return (
            <Form className="assignment-edit__form modal-form">
                <div className="toggle--wrapper">
                    <FormRow className="assignment-edit__on-demand">
                        <Toggle checked={assignment.performanceSupport}
                                disabled={assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE}
                                icons={false}
                                id="togglePerformanceSupport"
                                name="performanceSupport"
                                onChange={handleChange.bind(this)} />
                        <label htmlFor="togglePerformanceSupport">On Demand</label>

                        <div className="on-demand-instructions">
                            Select this option if you want users to receive this content based on location or scanning codes and you do not want it to appear in the users' inboxes.
                        </div>
                    </FormRow>
                    <FormRow>
                            <Toggle checked={assignment.mandatory}
                                    disabled={(assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE) || assignment.performanceSupport === true}
                                    icons={false}
                                    id="toggleMandatory"
                                    name="mandatory"
                                    onChange={handleChange.bind(this)} />
                        <label htmlFor="toggleMandatory">Mandatory Assignment</label>
                    </FormRow>
                    <FormRow>
                        <Toggle checked={assignment.requireLocation}
                                disabled={assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE}
                                icons={false}
                                id="toggleRequireLocation"
                                name="requireLocation"
                                onChange={handleChange.bind(this)} />
                        <label htmlFor="toggleRequireLocation">Track Completion Location</label>
                    </FormRow>
                    <FormRow>
                        <Toggle checked={assignment.requireSignature}
                                disabled={assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE}
                                icons={false}
                                id="toggleRequireSignature"
                                name="requireSignature"
                                onChange={handleChange.bind(this)} />
                        <label htmlFor="toggleRequireSignature">Signature Required</label>
                    </FormRow>
                </div>

                {assignment.requireSignature === true ? (
                    <FormRow>
                        <TextArea name="signaturePrompt"
                                  disabled={assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE}
                                  placeholder="Add optional signature instructions"
                                  onChange={handleChange.bind(this)}
                                  value={assignment.signaturePrompt} />
                    </FormRow>
                ) : null}

                <div className="assignment-edit__recurring assignment-edit__dates">
                    <FormRow>
                        <div>
                            <Icon icon="calendar" /> Recurring Frequency
                        </div>
                        <div className="recurring__action-menu">
                            <button type="button"
                                    className="recurring__trigger"
                                    disabled={(assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE) || assignment.performanceSupport === true}
                                    onClick={this._handleTriggerClick.bind(this)}>
                                {assignment.recurrance} <Icon icon="carrot-right" />
                            </button>
                            <ActionMenu>
                                {RECURRING_FREQUENCY_OPTIONS.map((option) => {
                                    return (
                                        <ActionMenuButton type="button" onClick={handleRecurranceChange.bind(this, option.value, 'recurrance')} key={option.key}>
                                            {option.text}
                                        </ActionMenuButton>
                                    )
                                })}
                            </ActionMenu>
                        </div>
                    </FormRow>
                    {assignment.recurrance !== 'none' ? (
                        <FormRow>
                            <label htmlFor="dateRecurUntil" className="assignment-edit__date-label">
                                <Icon icon="calendar" /> Recur Until
                            </label>
                            <div className={classNames('assignment-edit__datepicker--wrapper', {'date-not-set': assignment.recurUntil === 'none' || assignment.recurUntil == null, 'disabled': assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE})}>
                                <DatePicker id="dateRecurUntil"
                                            disabled={(assignment.state !== ASSIGNMENT_STATES.UNPUBLISHED && assignment.state !== ASSIGNMENT_STATES.NONE) || assignment.performanceSupport === true}
                                            dateFormat="M/D/YY"
                                            name="recurUntil"
                                            selected={assignment.recurUntil === 'none' ? null : moment(assignment.recurUntil)}
                                            {...$field('recurUntil', (event) => handleDateChange(event, 'recurUntil'))}
                                            placeholder="Recur Until" />
                                {$validation.recurUntil.show && <FormValidationMessage>{$validation.recurUntil.error.reason}</FormValidationMessage>}
                                {assignment.recurUntil === 'none' || assignment.recurUntil == null ? (
                                        <label htmlFor="dateRecurUntil" className="assignment-edit__dates--not-now">
                                            Forever <Icon icon="carrot-right" />
                                        </label>
                                    ) : null}
                                {assignment.recurUntil !== 'none' ? (
                                        <button className="assignment-edit__clear-recur-until"
                                                onClick={handleDateChange.bind(this, 'none', 'recurUntil')}
                                                type="button">
                                            <Icon icon="close" />
                                        </button>
                                    ) : null}
                            </div>
                        </FormRow>
                    ) : null}
                </div>


                <div className="modal__buttons">
                    <ModalButton disabled={isSaving === true}
                                 icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={cancelAdvancedChanges.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        )
    }
};

function assignmentEditAdvancedFormValidationConfig(props) {
    const { recurrance, recurUntil, startDate } = props.assignment;
    return {
        fields: ['recurUntil'],
        validations: {
            recurUntil: [
                [isRequiredIfRecurringFrequencySelected, recurUntil, recurrance, startDate]
            ]
        }
    }
}

export default AssignmentEditAdvancedForm = validated(assignmentEditAdvancedFormValidationConfig)(AssignmentEditAdvancedForm);

function isRequiredIfRecurringFrequencySelected(recurUntil, recurrance, startDate) {
    if(recurrance === 'none' || recurUntil === 'none') {
        return null;
    }

    let unitLookup = {
        daily: 'days',
        weekly: 'weeks',
        monthly: 'months',
        yearly: 'years'
    };

    if(startDate == null) {
        startDate = moment();
    }

    let endDate = moment(startDate).add(1, unitLookup[recurrance]);
    if(moment(recurUntil).isAfter(endDate)) {
        return null;
    } else {
        return 'Please select a date after the first recurrance interval.'
    }
}




// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentEditAdvancedForm.js